import ResponsiveHelper from "../utils/ResponsiveHelper";
// import Swiper from "swiper/bundle";

export default class About {
  constructor(dom) {
    this.dom = dom;
    window.addEventListener("resize", () => this.resize());
  }
  init() {
    this.initResponsiveHelper();
    // this.initHeroSlider();
    this.updateSlider();
    // this.initProductsSilder();
    // this.initWorkshopSlider();
  }

  initResponsiveHelper() {
    this.rHelper = new ResponsiveHelper();
    window.addEventListener("onBreakpointChange", (e) => {
      //console.log(e.detail);
      this.updateSlider();
    });
  }

  updateSlider() {
    setTimeout(() => {
      let slider = this.dom.querySelector(".hero-banner--slider");
      if (slider) {
        const style = slider.style;
        // var height = slider.clientHeight;
        // console.log(height);
        // style.setProperty("--svh", `${slider.clientHeight}px`);
        // document.body.style.setProperty("--svh", `${slider.clientHeight}px`);
        document.body.style.setProperty("--svh", `${slider.scrollHeight}px`);
      }
    }, 100);

    // console.log(style);
  }

  resize() {
    // console.log("resize from Homepage.js");
    this.updateSlider();
  }
}
